import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlatform } from '../../hooks/usePlatform';

interface WebOnlyRouteProps {
  children: React.ReactElement;
  redirectTo?: string;
}

export const WebOnlyRoute: React.FC<WebOnlyRouteProps> = ({ 
  children, 
  redirectTo = "/login" 
}) => {
  const { isNative } = usePlatform();

  if (isNative) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

